import React, { createContext, useContext, useEffect, useState, type PropsWithChildren } from 'react';
import { io, Socket, type ManagerOptions, type SocketOptions } from 'socket.io-client';

import authContext from '../auth/context/context';

interface SocketContextValue {
    socket: Socket | null;
    connected: boolean;
}

const SocketContext = createContext<SocketContextValue>({ socket: null, connected: false });

export const useSocket = () => useContext(SocketContext);

const SOCKET_CONFIG: Partial<ManagerOptions & SocketOptions> = {
    withCredentials: true,
    transports: ['websocket', 'polling'] as const
};
export function SocketProvider({ children }: PropsWithChildren) {
    const { isLoggedIn } = useContext(authContext);
    const [socket, setSocket] = useState<Socket | null>(null);
    // const [connected, setConnected] = useState(false);
    useEffect(() => {
        if (!isLoggedIn) {
            setSocket((prev) => {
                if (prev) prev.disconnect();
                return null;
            });
            // setConnected(false);
            return;
        }

        // Connect — same origin, credentials included for session cookie
        const socket = io(SOCKET_CONFIG);

        socket.on('connect_error', (err) => {
            console.error('[socket.io] connect error:', err.message);
        });

        setSocket(socket);

        return () => {
            socket.disconnect();
            setSocket(null);
            // setConnected(false);
        };
    }, [isLoggedIn]);
    const connected = socket?.connected ?? false;

    return <SocketContext.Provider value={{ socket, connected }}>{children}</SocketContext.Provider>;
}
